export const LeadSourcesColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "leadSource", headerName: "Lead Source", flex: 2 },
];

export const LeadStatusColumns = [
  { field: "id", headerName: "ID", flex: 0.2 },
  { field: "leadStatus", headerName: "Lead Status", flex: 2 },
];
